import Vue from 'vue'
import Router from 'vue-router'
import Home from '../container/HomeContainer'
import AllCourseContainer from '../container/AllCourseContainer'
import CourseInfoContainer from '../components/CourseInfo/CourseInfo'
import DataListContainer from '../container/DataListContainer'
import DataInfoContainer from '../container/DataInfoContainer'
import DemandContainer from '../container/DemandContainer'

import Video from '../components/VideoPlayer/VideoPlayer'

Vue.use(Router)

export default new Router({
    mode: 'history',
    //base: process.env.NODE_ENV === "production" ? "/portal" : "/",
    routes: [
        {
            // 首页
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/codeCallback',
            name: 'codeCallback',
            component: () => import('@/container/CodeCallbackContainer.vue')
        },
        {
            // 非法路由
            path: '*',
            redirect: '/'
        },
        {
            // 在线课程
            path: '/AllCourse',
            name: 'AllCourse',
            component: AllCourseContainer
        },
        {
            // 课程详情
            path: '/CourseInfo/:id',
            name: 'CourseInfo',
            component: CourseInfoContainer
        },
        {
            // 课程资料库
            path: '/DataList',
            name: 'DataList',
            component: DataListContainer
        },
        {
            // 资料详情
            path: '/DataInfo/:id',
            name: 'DataInfo',
            component: DataInfoContainer
        },
        {
            // 培训需求
            path: '/Demand',
            name: 'Demand',
            component: DemandContainer,
            meta: {
                requireAuth: true
            }
        },
        {
            // 视频播放demo
            path: '/Video',
            name: 'Video',
            component: Video
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js